import Cookies from 'js-cookie';

export const getCookieFlag = (featureName: string) => {
  return typeof window !== 'undefined' ? Cookies.get()[featureName] === 'true' : false;
};
